import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import '@babel/polyfill'
import '@mdi/font/css/materialdesignicons.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import LoginService from './Service/LoginService'
import AlarmasService from './Service/AlarmasService'
import BusquedaService from './Service/BusquedaService'
import DataService from './store/DataService'
import {moment} from './moment'
import i18n from './lang'
import './Service'
import AuthService from './AuthService'
//axios.defaults.baseURL="https...";
Vue.config.productionTip = false
Vue.prototype.$AuthService = new AuthService()
Vue.use(LoginService)
Vue.use(AlarmasService)
Vue.use(BusquedaService)
Vue.use(DataService)
Vue.use(VueAxios,axios)
Vue.use(require('vue-moment'), {
  moment
})

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
